<template lang="pug">
  .main
    base-header.pb-1
      b-row.py-4(align-v='center')
        b-col(cols='7' lg='6')
          h6.h2.text-white.d-inline-block.mb-0 LLM-Einstellungen

    b-container.mt-4(fluid, v-if="config")
      b-tabs.llm-tabs(content-class="mt-4")
        b-tab(title="Prompts")
          p.text-muted.small Platzhalter in Prompts: dcc_catalog, page_count, filename, file_size_mb
          b-row(v-if="prompts !== null")
            b-col(cols='12' lg='4')
              .d-flex.justify-content-between.align-items-center.mb-3
                h5.mb-0 Prompts
                b-button(variant="secondary", size="sm", @click="createPrompt") Neu
              .list-group
                a.list-group-item.list-group-item-action(
                  v-for="item in prompts",
                  :key="item._id",
                  :class="{ active: selectedPrompt && selectedPrompt._id === item._id }",
                  @click.prevent="selectPrompt(item)"
                )
                  .d-flex.justify-content-between.align-items-center
                    span {{ item.name }}
                    span
                      b-badge(v-if="isActivePrompt(item)", variant="warning") Aktiv
                      b-badge.ml-1(:variant="item.role === 'system' ? 'info' : 'secondary'") {{ item.role }}
                  .small.text-muted.text-truncate {{ (item.description || item.template) }}

            b-col(cols='12' lg='8', v-if="selectedPrompt")
              b-card
                b-form(@submit.prevent="savePrompt")
                  b-row
                    b-col(cols='8')
                      b-form-group(label="Name")
                        b-form-input(v-model="selectedPrompt.name", required)
                    b-col(cols='4')
                      b-form-group(label="Rolle")
                        b-form-select(v-model="selectedPrompt.role", :options="promptRoleOptions")
                  b-form-group(label="Beschreibung (optional)")
                    b-form-input(v-model="selectedPrompt.description")
                  b-form-group(label="Template")
                    textarea.form-control(v-model="selectedPrompt.template", rows="14")

                  .d-flex.justify-content-between.mt-4
                    div
                      b-button(variant="danger", @click="deletePrompt", :disabled="savingPrompt") Löschen
                      b-button.ml-2(
                        variant="outline-primary",
                        @click="setActivePrompt",
                        :disabled="savingPrompt || !selectedPrompt._id || isActivePrompt(selectedPrompt)"
                      ) Als aktiv festlegen
                    b-button(variant="primary", type="submit", :disabled="savingPrompt") Speichern

        b-tab(title="Modell")
          b-row(v-if="models !== null")
            b-col(cols='12' lg='4')
              .d-flex.justify-content-between.align-items-center.mb-3
                h5.mb-0 Modelle
                b-button(variant="secondary", size="sm", @click="createModel") Neu
              .list-group
                a.list-group-item.list-group-item-action(
                  v-for="item in models",
                  :key="item._id",
                  :class="{ active: selectedModel && selectedModel._id === item._id }",
                  @click.prevent="selectModel(item)"
                )
                  .d-flex.justify-content-between.align-items-center
                    span {{ item.name }}
                    b-badge(v-if="config.default_model_id === item._id", variant="warning") Standard
                  .small.text-muted {{ item.deployment }}

            b-col(cols='12' lg='8', v-if="selectedModel")
              b-card
                b-form(@submit.prevent="saveModel")
                  b-form-group(label="Name")
                    b-form-input(v-model="selectedModel.name", required)
                  b-form-group(label="Deployment (Azure)")
                    b-form-input(v-model="selectedModel.deployment", required)
                  b-row
                    b-col(cols='6')
                      b-form-group(label="Temperature")
                        b-form-input(type="number", step="0.1", v-model.number="selectedModel.temperature")
                    b-col(cols='6')
                      b-form-group(label="Max Tokens (leer = unbegrenzt)")
                        b-form-input(type="number", v-model.number="selectedModel.max_tokens")
                  b-form-group(label="API Version (optional)")
                    b-form-input(v-model="selectedModel.api_version", placeholder="z.B. 2024-04-01-preview")

                  .d-flex.justify-content-between.mt-4
                    div
                      b-button(variant="danger", @click="deleteModel", :disabled="savingModel") Löschen
                      b-button.ml-2(
                        variant="outline-primary",
                        @click="setDefaultModel",
                        :disabled="savingModel || config.default_model_id === selectedModel._id || !selectedModel._id"
                      ) Als Standard festlegen
                    b-button(variant="primary", type="submit", :disabled="savingModel") Speichern

              b-card.mt-3
                b-form-group(label="Prompt-Version (global)")
                  input.form-control(v-model="config.prompt_version")
                p.small.text-muted.mb-0 Wird mit „Speichern“ unten gespeichert.

        b-tab(title="PDF & Limits")
          b-row
            b-col(md="6")
              label Seiten pro Chunk
              input.form-control(type="number", v-model.number="config.pdf_chunk_pages")
              label.mt-2 Overlap-Seiten
              input.form-control(type="number", v-model.number="config.pdf_overlap_pages")
              label.mt-2 Max. PDF-Größe (MB) pro Request
              input.form-control(type="number", v-model.number="config.max_pdf_size_mb")
              label.mt-2 Max. Seiten pro Einzel-Request
              input.form-control(type="number", v-model.number="config.single_request_max_pages")
              label.mt-2 Max. Seiten pro Dokument
              input.form-control(type="number", v-model.number="config.max_llm_pages_per_document")

        b-tab(title="Budget & Flags")
          b-row
            b-col(md="6")
              label Tagesbudget (EUR, leer = kein Limit)
              input.form-control(type="number", step="0.01", v-model.number="config.daily_budget_usd")
              label.mt-2 Monatsbudget (EUR)
              input.form-control(type="number", step="0.01", v-model.number="config.monthly_budget_usd")
              b-form-checkbox.mt-3(v-model="config.enabled") LLM-Verarbeitung aktiv
              b-form-checkbox.mt-2(v-model="config.allow_llm_prototype") LLM-Prototyp für Projekte erlauben

        b-tab(title="Kosten-Historie")
          table.table.table-sm.table-striped(v-if="usageLogs.length")
            thead
              tr
                th Zeit
                th Projekt
                th Dokument
                th Prompt
                th Tokens (In / Out)
                th Kosten
                th OK
            tbody
              tr(v-for="log in usageLogs", :key="log._id")
                td {{ formatDate(log.created_at) }}
                td.small {{ log.project_id || '—' }}
                td.small
                  a(
                    v-if="log.document_id && log.project_id"
                    :href="'/dashboard/' + log.project_id + '?openDocument=' + log.document_id"
                    target="_blank"
                    title="Dokument öffnen"
                  ) {{ log.document_id.slice(-6) }} ↗
                  span(v-else) —
                td {{ log.prompt_key }}
                td {{ log.input_tokens }} / {{ log.output_tokens }}
                td {{ log.cost.toFixed(4) }} €
                td(:class="log.success ? 'text-success' : 'text-danger'") {{ log.success ? '✓' : '✗' }}
          p.text-muted(v-else) Noch keine LLM-Aufrufe protokolliert.

      b-row.mt-3
        b-col
          b-button(variant="primary", @click="save") Speichern
          b-button.ml-2(variant="secondary", @click="fetchUsage") Kosten aktualisieren
</template>

<script>
export default {
  data() {
    return {
      config: null,
      usageLogs: [],
      models: null,
      selectedModel: null,
      savingModel: false,
      prompts: null,
      selectedPrompt: null,
      savingPrompt: false,
      promptRoleOptions: [
        { value: 'system', text: 'System' },
        { value: 'user', text: 'User' },
      ],
    };
  },
  methods: {
    isActivePrompt(prompt) {
      if (!this.config || !prompt) return false;
      return (
        this.config.active_system_prompt_id === prompt._id ||
        this.config.active_user_prompt_id === prompt._id
      );
    },
    async fetchPrompts() {
      const response = await this.axios.get(this.base_url + '/llm/prompts');
      this.prompts = response.data || [];
      if (this.selectedPrompt) {
        const updated = this.prompts.find(p => p._id === this.selectedPrompt._id);
        if (updated) {
          this.selectedPrompt = this.normalizePrompt(this.$_.cloneDeep(updated));
        } else if (this.selectedPrompt._id) {
          this.selectedPrompt = null;
        }
      }
    },
    normalizePrompt(data) {
      return {
        _id: data._id || null,
        name: data.name || '',
        role: data.role || 'system',
        template: data.template || '',
        description: data.description || '',
      };
    },
    selectPrompt(item) {
      this.selectedPrompt = this.normalizePrompt(this.$_.cloneDeep(item));
    },
    createPrompt() {
      this.selectedPrompt = this.normalizePrompt({
        _id: null,
        name: 'Neuer Prompt',
        role: 'system',
        template: '',
        description: '',
      });
    },
    payloadFromSelectedPrompt() {
      return {
        name: this.selectedPrompt.name,
        role: this.selectedPrompt.role,
        template: this.selectedPrompt.template || '',
        description: this.selectedPrompt.description || null,
      };
    },
    async savePrompt() {
      this.savingPrompt = true;
      try {
        const payload = this.payloadFromSelectedPrompt();
        if (this.selectedPrompt._id) {
          await this.axios.put(
            this.base_url + '/llm/prompts/' + this.selectedPrompt._id,
            payload
          );
        } else {
          const response = await this.axios.post(
            this.base_url + '/llm/prompts',
            payload
          );
          this.selectedPrompt._id = response.data._id;
        }
        this.$bvToast.toast('Prompt gespeichert', {
          title: 'Gespeichert',
          variant: 'primary',
          autoHideDelay: 2000,
        });
        await this.fetchPrompts();
      } catch (err) {
        const detail = err.response && err.response.data && err.response.data.detail;
        this.$bvToast.toast(detail || 'Speichern fehlgeschlagen', {
          title: 'Fehler',
          variant: 'danger',
          autoHideDelay: 4000,
        });
      } finally {
        this.savingPrompt = false;
      }
    },
    deletePrompt() {
      if (!this.selectedPrompt || !this.selectedPrompt._id) {
        this.selectedPrompt = null;
        return;
      }
      this.$bvModal.msgBoxConfirm('Soll der Prompt "' + this.selectedPrompt.name + '" wirklich gelöscht werden?')
        .then(async (value) => {
          if (!value) return;
          try {
            await this.axios.delete(this.base_url + '/llm/prompts/' + this.selectedPrompt._id);
            this.selectedPrompt = null;
            await this.fetchPrompts();
            this.$bvToast.toast('Prompt gelöscht', {
              title: 'Gelöscht',
              variant: 'primary',
              autoHideDelay: 2000,
            });
          } catch (err) {
            const detail = err.response && err.response.data && err.response.data.detail;
            this.$bvToast.toast(detail || 'Löschen fehlgeschlagen', {
              title: 'Fehler',
              variant: 'danger',
              autoHideDelay: 4000,
            });
          }
        });
    },
    async setActivePrompt() {
      if (!this.selectedPrompt || !this.selectedPrompt._id) return;
      this.savingPrompt = true;
      try {
        const payload = this.selectedPrompt.role === 'system'
          ? { active_system_prompt_id: this.selectedPrompt._id }
          : { active_user_prompt_id: this.selectedPrompt._id };
        const response = await this.axios.put(
          this.base_url + '/configuration/llm/active-prompts',
          payload
        );
        this.config = response.data;
        this.$bvToast.toast('Aktiver Prompt festgelegt', {
          title: 'Gespeichert',
          variant: 'primary',
          autoHideDelay: 2000,
        });
      } catch (err) {
        const detail = err.response && err.response.data && err.response.data.detail;
        this.$bvToast.toast(detail || 'Festlegen fehlgeschlagen', {
          title: 'Fehler',
          variant: 'danger',
          autoHideDelay: 4000,
        });
      } finally {
        this.savingPrompt = false;
      }
    },
    formatDate(d) {
      if (!d) return '—';
      return new Date(d).toLocaleString('de-DE');
    },
    fetch() {
      this.axios.get(this.base_url + '/configuration/llm').then((res) => {
        this.config = res.data;
      });
    },
    async fetchModels() {
      const response = await this.axios.get(this.base_url + '/llm/models');
      this.models = response.data || [];
      if (this.selectedModel) {
        const updated = this.models.find(m => m._id === this.selectedModel._id);
        if (updated) {
          this.selectedModel = this.normalizeModel(this.$_.cloneDeep(updated));
        } else if (this.selectedModel._id) {
          this.selectedModel = null;
        }
      }
    },
    normalizeModel(data) {
      return {
        _id: data._id || null,
        name: data.name || '',
        deployment: data.deployment || '',
        temperature: data.temperature != null ? data.temperature : 1.0,
        max_tokens: data.max_tokens != null ? data.max_tokens : null,
        api_version: data.api_version || '',
      };
    },
    selectModel(item) {
      this.selectedModel = this.normalizeModel(this.$_.cloneDeep(item));
    },
    createModel() {
      this.selectedModel = this.normalizeModel({
        _id: null,
        name: 'Neues Modell',
        deployment: '',
        temperature: 1.0,
        max_tokens: null,
        api_version: '',
      });
    },
    payloadFromSelectedModel() {
      return {
        name: this.selectedModel.name,
        deployment: this.selectedModel.deployment,
        temperature: this.selectedModel.temperature,
        max_tokens: this.selectedModel.max_tokens || null,
        api_version: this.selectedModel.api_version || null,
      };
    },
    async saveModel() {
      this.savingModel = true;
      try {
        const payload = this.payloadFromSelectedModel();
        if (this.selectedModel._id) {
          await this.axios.put(
            this.base_url + '/llm/models/' + this.selectedModel._id,
            payload
          );
        } else {
          const response = await this.axios.post(
            this.base_url + '/llm/models',
            payload
          );
          this.selectedModel._id = response.data._id;
        }
        this.$bvToast.toast('Modell gespeichert', {
          title: 'Gespeichert',
          variant: 'primary',
          autoHideDelay: 2000,
        });
        await this.fetchModels();
      } finally {
        this.savingModel = false;
      }
    },
    deleteModel() {
      if (!this.selectedModel || !this.selectedModel._id) {
        this.selectedModel = null;
        return;
      }
      this.$bvModal.msgBoxConfirm('Soll das Modell "' + this.selectedModel.name + '" wirklich gelöscht werden?')
        .then(async (value) => {
          if (!value) return;
          try {
            await this.axios.delete(this.base_url + '/llm/models/' + this.selectedModel._id);
            this.selectedModel = null;
            await this.fetchModels();
            this.$bvToast.toast('Modell gelöscht', {
              title: 'Gelöscht',
              variant: 'primary',
              autoHideDelay: 2000,
            });
          } catch (err) {
            const detail = err.response && err.response.data && err.response.data.detail;
            this.$bvToast.toast(detail || 'Löschen fehlgeschlagen', {
              title: 'Fehler',
              variant: 'danger',
              autoHideDelay: 4000,
            });
          }
        });
    },
    async setDefaultModel() {
      if (!this.selectedModel || !this.selectedModel._id) return;
      this.savingModel = true;
      try {
        const response = await this.axios.put(
          this.base_url + '/configuration/llm/default-model',
          { model_id: this.selectedModel._id }
        );
        this.config = response.data;
        this.$bvToast.toast('Standardmodell festgelegt', {
          title: 'Gespeichert',
          variant: 'primary',
          autoHideDelay: 2000,
        });
      } finally {
        this.savingModel = false;
      }
    },
    fetchUsage() {
      this.axios.get(this.base_url + '/llm/usage/logs?limit=50').then((res) => {
        this.usageLogs = res.data;
      });
    },
    save() {
      this.axios.post(this.base_url + '/configuration/llm', this.config).then(() => {
        this.$bvToast.toast('LLM-Einstellungen gespeichert', {
          title: 'Gespeichert',
          variant: 'primary',
          autoHideDelay: 2000,
        });
        this.fetch();
      });
    },
  },
  mounted() {
    this.fetch();
    this.fetchModels();
    this.fetchPrompts();
    this.fetchUsage();
  },
};
</script>

<style scoped>
.llm-tabs >>> .nav-tabs {
  border-bottom: 2px solid #e9ecef;
}

.llm-tabs >>> .nav-tabs .nav-link {
  font-weight: 600;
  font-size: 0.9rem;
  color: #6c757d;
  padding: 0.65rem 1.25rem;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -2px;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.llm-tabs >>> .nav-tabs .nav-link:hover {
  color: #344767;
  border-bottom-color: #adb5bd;
}

.llm-tabs >>> .nav-tabs .nav-link.active {
  color: #fb6340;
  border-bottom-color: #fb6340;
  background: transparent;
}

.list-group-item.active {
  background-color: #003c50;
  border-color: #003c50;
}
</style>
